import { render } from "./errorModal.vue?vue&type=template&id=132e9de0&scoped=true&ts=true"
import script from "./errorModal.ts?vue&type=script&lang=ts"
export * from "./errorModal.ts?vue&type=script&lang=ts"

import "./errorModal.scss?vue&type=style&index=0&id=132e9de0&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132e9de0"]])

export default __exports__